import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { User }                                           from '../../models/user';
import { UserService}                                     from '../../services/user.service';
import { AuthService }                                    from '../../../providers/auth.service';
import { RoleService }                                     from '../../services/role.service'
import { Router }                                         from '@angular/router';
import { Location }                                       from '@angular/common';
import { Subject }                                        from 'rxjs/Subject';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'users',
  templateUrl: 'user.component.html',
  styleUrls: ["user.component.scss"]
})
export class UserComponent implements OnInit {

    private ngUnsubscribe: Subject<void> = new Subject<void>();
    private roles: any[] = [];
    private selectedRoles: any[] = [];
    private data = {
      password: ""
    };
    private user = new User("", "", "", "", [], new Date(), false);

    constructor(
      private UserService: UserService,
      private RoleService: RoleService,
      private router: Router,
      private authService: AuthService
    ) { }

    ngOnInit(): void {
      this.authService.getUser().subscribe(user => {
        if(!user) {
          this.router.navigate(["/login"])
        }
      })
      this
        .RoleService
        .getRoles()
        .subscribe(roles => {
          this.roles = roles.map(role => { return {"id":role.id, "text":role.name}; });
          this.selectedRoles = this.user.roles.map(id => this.roles.find(role => role.id == id));
        })
    }

    add(user): void {
      this.user.roles = this.selectedRoles.map(role => role.id);
      this
        .UserService
        .create(user, this.data.password)
        .subscribe(user => {
          this.user = new User("", "", "", "", [], new Date(), false);
        });
    }

    setRoles(roles) {
      this.selectedRoles = roles;
    }

  }



// WEBPACK FOOTER //
// ./src/app/users/components/user-add/user.component.ts